// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3Y-6hfAVy2MF_hsuYhs0w6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/InputIcon/style.css
// module id = 244
// module chunks = 42